import { ratePriceAdjustmentIdZodSchema } from "@@/shared/acquire/accommodation-engine/rate-price-adjustment-id";
import { dateRangeZodObject } from "@@/shared/date-time/date-range";
import {
    isoAndUnixZodSchema,
    nowIsoAndUnix,
} from "@@/shared/date-time/iso-and-unix";
import { idZodSchema } from "@@/shared/id";
import { productIdZodSchema } from "@@/shared/products/product-id";
import { providerIdZodSchema } from "@@/shared/providers/provider-id";
import { generateId } from "@@/utilities/generate-id";
import { z } from "zod";

const deleteRatePriceAdjustmentCommandZodObject = z.object({
    _id: idZodSchema,
    _type: z.literal("DELETE_RATE_PRICE_ADJUSTMENT_COMMAND"),
    _createdAt: isoAndUnixZodSchema,
    providerId: providerIdZodSchema,
    productId: productIdZodSchema,
    ratePriceAdjustmentId: ratePriceAdjustmentIdZodSchema.or(
        z.array(ratePriceAdjustmentIdZodSchema),
    ),
    /**
     * Optional, define if you need to delete only part of
     * the rate price adjustment. If not defined, the whole rate
     * price adjustment will be deleted.
     */
    dateRange: dateRangeZodObject.optional(),
});

type DeleteRatePriceAdjustmentCommand = z.infer<
    typeof deleteRatePriceAdjustmentCommandZodObject
>;

const deleteRatePriceAdjustmentCommandFactoryParamsZodObject =
    deleteRatePriceAdjustmentCommandZodObject.omit({
        _id: true,
        _type: true,
        _createdAt: true,
    });

type FactoryParams = z.infer<
    typeof deleteRatePriceAdjustmentCommandFactoryParamsZodObject
>;

const deleteRatePriceAdjustmentCommandFactory = (params: FactoryParams) => {
    const editCommand: DeleteRatePriceAdjustmentCommand = {
        ...params,
        _id: generateId({
            prefix: "delete_rate_price_adjustment_command__",
        }),
        _type: "DELETE_RATE_PRICE_ADJUSTMENT_COMMAND",
        _createdAt: nowIsoAndUnix(),
    };
    return editCommand;
};

export {
    deleteRatePriceAdjustmentCommandFactory,
    deleteRatePriceAdjustmentCommandFactoryParamsZodObject,
    deleteRatePriceAdjustmentCommandZodObject,
};
export type {
    DeleteRatePriceAdjustmentCommand,
    FactoryParams as DeleteRatePriceAdjustmentCommandFactoryParams,
};
